export default __webpack_public_path__ + "static/media/tools.5becf9a6.svg";